module.exports = "/images/Icon industry-ThemePark.svg?caa52356d046c0ff9659447af08dc0df";